

















import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { StoreState } from '../../../store';

@Component({
     mounted: function() {
        // this.$store.commit('ANSWERED_YES_CHANGE',{});
        // this.$store.commit('ANSWERED_NO_CHANGE',{});
     },
    computed: {
        ...mapState({
            'answeredYes': (state: StoreState) => state.reports.filters.answeredYes_schedule,
            'answeredNo': (state: StoreState) => state.reports.filters.answeredNo_schedule,
        })
    }
})
export default class AnsweredFilterSchedul extends Vue {

    answeredYesCheckChanged(newVal: any) {
        this.$store.commit('ANSWERED_YES_CHANGE_SCHEDULE', {
            newVal
        });
    }

    answeredNoCheckChanged(newVal: any) {
        this.$store.commit('ANSWERED_NO_CHANGE_SCHEDULE', {
            newVal
        });
    }
}
